import React from 'react';
import { Button } from 'antd';
import { RightOutlined } from '@ant-design/icons';

type ViewDetailsButtonProps = {
  onClick: () => void;
  text?: string;
};

const ViewDetailsButton: React.FC<ViewDetailsButtonProps> = ({
  onClick,
  text = 'View',
}) => {
  return (
    <div className="ml-auto">
      <Button
        type="link"
        className="text-[#2D5BFF]"
        style={{
          lineHeight: 1,
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          padding: 0,
        }}
        onClick={onClick}
      >
        {text} <RightOutlined />
      </Button>
    </div>
  );
};

export default ViewDetailsButton;
